import { render } from "./ParticipacionJrvStreamlined.vue?vue&type=template&id=7cb28606&scoped=true"
import script from "./ParticipacionJrvStreamlined.vue?vue&type=script&lang=ts"
export * from "./ParticipacionJrvStreamlined.vue?vue&type=script&lang=ts"

import "./ParticipacionJrvStreamlined.vue?vue&type=style&index=0&id=7cb28606&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7cb28606"

export default script